import {logger} from 'yougile-util'
import {
  DataObjectId,
  GoogleCalendarIntegrationsStatus,
  GoogleCalendarOption,
  GoogleCalendarSettings
} from 'yougile-model'
import {Backend} from './backend'

export const googleCalendarSignIn = async (): Promise<void> => {
  try {
    const {url} = await Backend.postJSON<{url: string}>(
      '/data/google-calendar/login-url',
      {...Backend.loadCred(), origin: location.origin}
    )

    if (typeof url === 'string' && url) {
      window.open(url, '_blank')
    }
  } catch (error) {
    logger.log(error)
  }
}

export const setGoogleCalendarAuthCode = async (
  code: string
): Promise<void> => {
  await Backend.postJSON('/data/google-calendar/auth-code', {
    code,
    origin: location.origin,
    ...Backend.loadCred()
  })
}

export const setGoogleCalendarStatus = async (
  status: GoogleCalendarIntegrationsStatus
): Promise<void> => {
  await Backend.postJSON('/data/google-calendar/set-status', {
    status,
    ...Backend.loadCred()
  })
}

interface GoogleCalendarDataHandler {
  settings?: GoogleCalendarSettings
  status?: GoogleCalendarIntegrationsStatus
  calendarOptions: GoogleCalendarOption[]
  userEmail: string
}
export const getGoogleCalendarSettingsData = async (
  companyId: DataObjectId
): Promise<GoogleCalendarDataHandler | undefined> => {
  try {
    const data: GoogleCalendarDataHandler & {result: string} =
      await Backend.postJSON('/data/google-calendar/data', {
        companyId,
        ...Backend.loadCred()
      })
    if (data.result !== 'ok') {
      return undefined
    }

    return {
      settings: data.settings,
      status: data.status,
      calendarOptions: data.calendarOptions,
      userEmail: data.userEmail
    }
  } catch (error) {
    logger.log(error)
    return undefined
  }
}

export const resetGoogleCalendarSync = async (
  calendarId?: string
): Promise<void> => {
  await Backend.postJSON('/data/google-calendar/reset', {
    calendarId,
    ...Backend.loadCred()
  })
}

export const setGoogleCalendarSettings = async (
  settings: GoogleCalendarSettings,
  formIsChanged: boolean
): Promise<void> => {
  await Backend.postJSON('/data/google-calendar/set-settings', {
    settings,
    clearBeforeUpdate: formIsChanged,
    ...Backend.loadCred()
  })
}
